import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import LibraryFormThemesGrid from './LibraryFormThemesGrid';

const LibraryFormThemesGridBridge = react2angular(LibraryFormThemesGrid, []);

export default LibraryFormThemesGridBridge;
